var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManBeard1A(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 720 720",
    enableBackground: "new 0 0 720 720",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "frame_730px"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -4.8,
    y: -4.9,
    fill: "none",
    stroke: "#0000FF",
    strokeWidth: 0.25,
    strokeOpacity: 0,
    width: 730,
    height: 730
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "type5_x5F_beards"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_x36_",
    fill: "#862618",
    d: "M360,372.5c3.3,0,9.4-0.2,12.7-0.1c3.8,0.1,4.1-0.3,4.3,3.2c0.1,2.3,0.2,2.9-0.9,4.2 c-2.1,2.5-5.5,4.7-7.1,5.8c-0.5,0.4-3.1,2.1-3.6,2.4c3.4,5,5.9,8.4,12.3,8.8c5.3,0.3,9.8,0,14.3-2.4c4.6-2.4,9-5.6,14-8.9 c2.7-1.8,9.1-7.4,11-8.8c2-1.4,9.2-8,11.3-8.8c-6.8,11.2-16.5,23.1-24,29.2c-7.8,6.4-16.2,16-26.5,16.5c-12.2,0.6-36.1,3.1-47-2.5 c-9.1-4.7-8.9-6.2-17-12.2c-9.6-8.1-19.5-21-24-30.8c5,3.8,14.6,12.5,16.5,13.8c9,6,10.7,8.1,20,12c4.9,2,13.1,3.5,18.6,1.8 c2.5-0.8,4.4-2.2,6.2-3.9c0.9-0.8,3.2-3.1,3.5-4.2c0,0-0.4-0.3-2.1-1.7c-2.8-2.3-7.5-4.6-9-7.4c-0.9-1.7-0.9-4.7,0.4-5.5 c0.8-0.5,5.2-0.4,6.2-0.4c3-0.1,6.6-0.1,7.6-0.1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManBeard1A);
export default __webpack_public_path__ + "static/media/man_beard_1a.a78b01dc567caf9da16e275490c78913.svg";
export { ForwardRef as ReactComponent };